var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "m11.702 6.502.62-.421-.62.421Zm-1.405-2.065.62-.422-.62.422ZM19 6.19h-6.471v1.5H19v-1.5Zm-6.471 0a.25.25 0 0 1-.207-.11l-1.24.843c.325.48.868.767 1.447.767v-1.5Zm-.207-.11-1.405-2.065-1.24.844 1.405 2.065 1.24-.844Zm-1.405-2.065A1.75 1.75 0 0 0 9.47 3.25v1.5c.082 0 .16.04.206.11l1.24-.845ZM9.47 3.25H5v1.5h4.471v-1.5ZM5 3.25A2.75 2.75 0 0 0 2.25 6h1.5c0-.69.56-1.25 1.25-1.25v-1.5ZM2.25 6v12h1.5V6h-1.5Zm0 12A2.75 2.75 0 0 0 5 20.75v-1.5c-.69 0-1.25-.56-1.25-1.25h-1.5ZM5 20.75h14v-1.5H5v1.5Zm14 0A2.75 2.75 0 0 0 21.75 18h-1.5c0 .69-.56 1.25-1.25 1.25v1.5ZM21.75 18V8.94h-1.5V18h1.5Zm0-9.06A2.75 2.75 0 0 0 19 6.19v1.5c.69 0 1.25.56 1.25 1.25h1.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;